import { render, staticRenderFns } from "./classRecord.vue?vue&type=template&id=7186b5a2&scoped=true&"
import script from "./classRecord.vue?vue&type=script&lang=js&"
export * from "./classRecord.vue?vue&type=script&lang=js&"
import style0 from "./classRecord.vue?vue&type=style&index=0&id=7186b5a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7186b5a2",
  null
  
)

export default component.exports